<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <action-button type="save" @click="save" />

      <action-button type="delete" @click="del(attendee.id)" v-if="$can('attendee-delete')" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="attendee.participant.first_name"
                  v-model="participant.first_name"
                  :label="$t('participants.first_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="attendee.participant.last_name"
                  v-model="participant.last_name"
                  :label="$t('participants.last_name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="attendee.course.name"
                  v-model="course.name"
                  :label="$t('attendees.course_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="attendee.organisation.name"
                  v-model="organisation.name"
                  :label="$t('attendees.enrolled_organisation_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="attendee.enrolled_date"
                  v-model="attendee.enrolled_date"
                  :label="$t('attendees.enrolled_date')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-2">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("attendees.other_title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox v-model="attendee.course_attended" :label="$t('attendees.course_attended')"></v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox v-model="attendee.course_photo_taken" :label="$t('attendees.course_photo_taken')"></v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox v-model="attendee.course_practice_completed" :label="$t('attendees.course_practice_completed')"></v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox v-model="attendee.course_completed" :label="$t('attendees.course_completed')"></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  name="attendee.comment"
                  v-model="attendee.comment"
                  v-validate="'max:1000'"
                  :label="$t('attendees.comment')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "AttendeeView",

  props: ["id"],

  data() {
    return {
      page_title: "",
      attendee: {},
      course: {},
      participant: {},
      organisation: {}
    }
  },

  created() {
    axios
      .get(this.API_URL + "attendee/" + this.id)
      .then((res) => {
        this.attendee = res.data.data
        this.course = this.attendee.course
        this.participant = this.attendee.participant
        this.organisation = this.attendee.organisation

        this.page_title = this.$t("attendees.view_attendee", { name: this.attendee.title })
      })
      .catch((err) => console.log(err))
  },

  computed: {
    computedEnrolmentDate() {
      return this.attendee.enrolled_date ? this.moment.utc(this.attendee.enrolled_date).format(this.DATE_FORMAT) : ""
    }
  },

  methods: {
    save() {
      let vm = this

      axios
        .put(this.API_URL + "attendee", {
          id: this.attendee.id,
          course_id: this.attendee.course_id,
          participant_id: this.attendee.participant_id,
          course_attended: this.attendee.course_attended,
          course_photo_taken: this.attendee.course_photo_taken,
          course_practice_completed: this.attendee.course_practice_completed,
          course_completed: this.attendee.course_completed,
          comment: this.attendee.comment
        })
        .then((res) => {
          vm.$awn.success(vm.$t("global.update_success"))
        })
        .catch((err) => console.log(err))
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "attendee/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/attendees")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
